import style from './index.module.scss';
import Invoice from '@/images/transfer/invoice2.png';
import back from '@/images/transfer/back.png';
import { Toast } from 'antd-mobile';
import { isHdl, HRouter, commonBridge } from '@haidilao-private/jsbridge';
import { APPID_MERBER } from '@/helper/common/constant';
const { REACT_APP_API_ENV = 'pro' } = process.env;

const TransferLd = () => {
  const onTransfer = () => {
    if (isHdl) {
      console.log('REACT_APP_API_ENV', REACT_APP_API_ENV);
      commonBridge('webGetAPPInformation', {}, () => {
        commonBridge('launchMiniprogram', {
          path: '/pages/my/index?hdl_source=超级APP',
          userName: APPID_MERBER,
          miniprogramType: REACT_APP_API_ENV == 'pro' ? '0' : '2',
        });
      });
    } else {
      Toast.show({
        content: '请在海底捞app中打开',
      });
    }
  };

  const onBack = () => {
    HRouter.back();
  };

  return (
    <div className={style.transferBox}>
      <img className={style.transferImg} src={Invoice} alt="" />
      <div className={style.backBox} onClick={onBack}>
        <img className={style.backs} src={back} />
      </div>
      <div className={style.transferbtn} onClick={onTransfer}></div>
    </div>
  );
};
export default TransferLd;
